export { TapHandler, tapEvent };

// Thanks! https://www.xjavascript.com/blog/capture-tap-event-with-pure-javascript/
 
// Usage:
// new TapHandler(document.getElementById('myButton'), { threshold: 10 });

const tapEvent = new Event( 'tap', {
	bubbles: true,       // Allow event to bubble up the DOM
	cancelable: true    // Allow preventDefault()
});

class TapHandler {
  constructor( selector, options = {} ) {
    this.selector = selector;
    this.config = { threshold: 5, timeout: 200, stopClick: false, ...options };
    this.state = { isActive: false, startTime: 0, startX: 0, startY: 0 };
    this.tapElements = document.querySelectorAll( this.selector );
		this.isTap = false;
    this.bindEvents();
  }
 
  bindEvents() {
		this.tapElements.forEach( thisElement => {
			thisElement.addEventListener('touchstart', (e) => this.onTouchStart(e));
			thisElement.addEventListener('touchmove', (e) => this.onTouchMove(e));
			thisElement.addEventListener('touchend', (e) => this.onTouchEnd(e));
			thisElement.addEventListener('touchcancel', () => this.onTouchCancel());
			if( this.config.stopClick ){
				thisElement.addEventListener('click', (e) => this.onClick(e));
			}
		});
  }
 
  onTouchStart(event) {
		const touch = event.touches[0]; // Get the first (and only) touch
		this.state.isActive = true;
		this.state.startTime = Date.now();
		this.state.startX = touch.clientX;
		this.state.startY = touch.clientY;
	}
  onTouchMove(event) {
		if (!this.state.isActive) return;
	
		const touch = event.touches[0];
		const deltaX = Math.abs(touch.clientX - this.state.startX);
		const deltaY = Math.abs(touch.clientY - this.state.startY);
	
		// Cancel tap if movement exceeds threshold
		if (deltaX > this.state.threshold || deltaY > this.state.threshold) {
			this.state.isActive = false;
		}
	}
  onTouchEnd(event) {
		if (!this.state.isActive) return;

		const duration = Date.now() - this.state.startTime;

		if (duration <= this.config.timeout) {
			this.isTap = true;
			event.target.dispatchEvent(tapEvent);			
		}
	
		// Reset state
		this.state.isActive = false;
	}
  onTouchCancel() { this.state.isActive = false; }

	onClick(event) {
		if( this.isTap ){
			event.preventDefault();
			this.isTap = false;
		}
	}
}
